import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

type OwnProps = WidgetProps;

interface ProductListPaginationStrip {
    wrapper?: InjectableCss;
}

export const styles: ProductListPaginationStrip = {
    wrapper: {
        css: css`
            > [class^="Wrapper"] {
                display: flex;
                flex-wrap: wrap;
                align-items: baseline;
                gap: 20px;
                > div:first-of-type {
                    width: 77px;
                }
                > button {
                    width: 242px;
                }
            }
        `,
    },
};

const ProductDetailsCtaButtonsContainer: FC<OwnProps> = ({ id }) => {
    return (
        <StyledWrapper {...styles.wrapper}>
            <Zone zoneName="buttonsContainer" contentId={id} />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: ProductDetailsCtaButtonsContainer,
    definition: {
        group: "Common",
        displayName: "Product Details Cta Buttons Container",
    },
};

export default widgetModule;
